import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

let authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;

if (import.meta.env.DEV) {
  authDomain = 'jarrell-01.firebaseapp.com';
}

const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-east4'); // Specify the region here

// Connect to the Functions emulator when in development
if (import.meta.env.DEV) {
  console.log('Connecting to Firebase Functions emulator on localhost:5001');
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    // console.log('Successfully connected to Firebase Functions emulator');
  } catch (error) {
    // console.warn('Failed to connect to Functions emulator (may already be connected):', error);
  }
}

export default app;
